// Entry point for the build script in your package.json

// IMPORTANT: Dark mode initialization MUST run synchronously before any
// rendering to prevent flash of wrong theme. Do NOT move this to a controller.
;(function() {
  const stored = localStorage.getItem("theme-mode")
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches
  const isDark = stored === "dark" || (stored === null && prefersDark)
  document.documentElement.classList.toggle("dark", isDark)
})()

import "@hotwired/turbo-rails"
import "./lib/google_analytics"
import "./controllers"
import { initFlowbite } from "flowbite"

// Suppress Flowbite tooltip errors for elements using custom Stimulus tooltip controller
const originalConsoleError = console.error
console.error = function(...args) {
  // Suppress Flowbite tooltip initialization errors (using custom Stimulus controller)
  if (args[0]?.includes?.('tooltip element') && args[0]?.includes?.('does not exist')) {
    return
  }
  originalConsoleError.apply(console, args)
}

document.addEventListener("turbo:load", initFlowbite)

import "trix"
import "@rails/actiontext"
